import { KeyRound } from 'lucide-react';
import { useT } from '../../i18n';
import { SetupCard } from '../ui';

/**
 * THE «TILGANGER» ENTRY IN THE ORGANIZATION'S SETTINGS (slice 3, decision 4A).
 *
 * Its own component rather than markup inside `ClubSettingsView`, for two
 * reasons. The settings view is a legacy surface whose strings are not yet in
 * the catalog, and this text must be — so it needs `useT`, which the settings
 * view's render-contract tests mount without a `LocaleProvider`. And the entry
 * is only ever rendered for an access manager: the shell passes `onOpenAccess`
 * when `/me` reports `organization.access.manage` in the current scope, and
 * the settings view renders nothing here otherwise. Nobody else sees a door
 * the server would refuse.
 */
export function AccessSettingsCard({ onOpen }: { onOpen: () => void }) {
  const t = useT();
  return (
    <SetupCard label={t('clubSettings.access.title')}>
      {/* STACKED, the button under the text (2026-10-21): the card sits in the
          settings' right-hand column now, and beside the button the sentence
          wrapped into a strip four words wide. */}
      <div className="flex flex-col gap-3">
        <p className="text-sm text-ink-2">{t('clubSettings.access.lead')}</p>
        <button
          type="button"
          onClick={onOpen}
          className="btn-outline text-xs self-start inline-flex items-center gap-1.5"
          data-testid="club-settings-open-access"
        >
          <KeyRound size={12} /> {t('clubSettings.access.open')}
        </button>
      </div>
    </SetupCard>
  );
}
